import type { ComponentMeta } from "@mijalowcode/types";
import { ComponentCategory, PropType } from "@mijalowcode/types";

export const CardMeta: ComponentMeta = {
  componentName: "Card",
  package: "@mijadesign/web",
  title: "卡片",
  description: "通用卡片容器",
  category: ComponentCategory.DATA_DISPLAY,
  visibleInComponentPanel: true,
  icon: "CreditCardOutlined",
  canHaveChildren: true,
  designToken: {
    fields: [
      { name: "headerBg", label: "头部背景", type: "color" },
      {
        name: "headerFontSize",
        label: "头部字号",
        type: "number",
        min: 10,
        max: 32,
      },
      {
        name: "borderRadiusLG",
        label: "大圆角",
        type: "number",
        min: 0,
        max: 48,
      },
    ],
  },
  props: [
    {
      name: "title",
      label: "标题",
      type: PropType.STRING,
      defaultValue: "卡片标题",
      group: "基础",
    },
    {
      name: "bordered",
      label: "边框",
      type: PropType.BOOLEAN,
      defaultValue: true,
      group: "样式",
    },
    {
      name: "hoverable",
      label: "悬浮效果",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "样式",
    },
    {
      name: "loading",
      label: "加载中",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "状态",
    },
    {
      name: "size",
      label: "尺寸",
      type: PropType.ENUM,
      defaultValue: "default",
      options: [
        { label: "默认", value: "default" },
        { label: "小", value: "small" },
      ],
      group: "基础",
    },
    {
      name: "extra",
      label: "右上角内容",
      type: PropType.STRING,
      description: "卡片右上角的操作区域",
      group: "内容",
    },
  ],
  defaultProps: {
    title: "卡片标题",
    bordered: true,
  },
  defaultStyle: {
    width: "100%",
    minHeight: 200,
    padding: 24,
  },
  preview: [
    {
      title: "基础卡片",
      props: {
        title: "卡片标题",
        children: "这里是卡片内容",
      },
    },
    {
      title: "悬浮卡片",
      props: {
        title: "可交互卡片",
        hoverable: true,
        extra: "更多",
        children: "悬浮时会有交互反馈",
      },
    },
  ],
  docLinks: [
    {
      title: "Card 文档",
      url: "https://https://5x-ant-design.antgroup.com//components/card-cn",
      source: "antd",
    },
  ],
  npm: {
    package: "@mijadesign/web",
    exportName: "Card",
  },
  snippet: {
    componentName: "Card",
    package: "@mijadesign/web",
    props: { title: "卡片标题" },
    children: [],
  },
};
